import { render, staticRenderFns } from "./zhuyuan-edit.vue?vue&type=template&id=5c6895e1&scoped=true&"
import script from "./zhuyuan-edit.vue?vue&type=script&lang=ts&"
export * from "./zhuyuan-edit.vue?vue&type=script&lang=ts&"
import style0 from "./zhuyuan-edit.vue?vue&type=style&index=0&id=5c6895e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6895e1",
  null
  
)

export default component.exports